export const dateQueryString = (startDate: Date, endDate: Date): string => {
  return `startDate=${startDate.toDateString()}&endDate=${endDate.toDateString()}`;
};
